export const muiCssBaselineTheme = {
  MuiCssBaseline: {
    styleOverrides: `
        * {
            scroll-behavior: smooth;
        }
        body {
            line-height: 1.5;
            letter-spacing: 0.00938em;
            font-family: "Inter", "Roboto", sans-serif;
        }

          h1,
          h2,
          h3,
          h4,
          h5,
          p {
            line-height: unset;
            margin: unset;
            font-weight: 400;
        }

        jdiv.__jivoDesktopButton,
        jdiv.__jivoMobileButton {
            display: none;
        }

        @font-face {
            font-family: "RF Rostin";
            src: url("/fonts/RF-Rostin-Regular.woff") format("woff");
            font-style: normal;
            font-weight: normal;
            font-display: swap;
        }

        @font-face {
            font-family: "RF Rostin";
            src: url("/fonts/RF-Rostin-Bold.woff") format("woff");
            font-style: normal;
            font-weight: bold;
            font-display: swap;
        }

        @font-face {
            font-family: "RF Rostin";
            src: url("/fonts/RF-Rostin-Light.woff") format("woff");
            font-style: italic;
            font-weight: normal;
            font-display: swap;
        }
        @font-face {
            font-family: "Inter";
            src: url("/fonts/Inter-Bold.ttf");
            font-weight: bold;
            font-style: normal;
            font-display: swap;
          }

          @font-face {
            font-family: "Inter";
            src: url("/fonts/Inter-Light.ttf");
            font-weight: 300;
            font-style: normal;
            font-display: swap;
          }

          @font-face {
            font-family: "Inter";
            src: url("/fonts/Inter-Regular.ttf");
            font-weight: 400;
            font-style: normal;
            font-display: swap;
          }
      `,
  },
};
